import {en, nl, SUPPORTED_LOCALES, DEFAULT_LOCALE} from './translations.js';

const LOCALE_KEY = 'wb_locale';
const LOCALES = {en, nl};

export function getLocale() {
    const stored = localStorage.getItem(LOCALE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
        return stored;
    }
    const browser = (navigator.language || '').slice(0, 2).toLowerCase();
    return SUPPORTED_LOCALES.includes(browser) ? browser : DEFAULT_LOCALE;
}

export function setLocale(loc) {
    if (SUPPORTED_LOCALES.includes(loc)) {
        localStorage.setItem(LOCALE_KEY, loc);
        document.dispatchEvent(new CustomEvent('locale-change'));
    }
}

export function t(key) {
    const locale = getLocale();
    const dict = LOCALES[locale] || en;
    return Object.prototype.hasOwnProperty.call(dict, key) ? dict[key] : key;
}

export function tpl(key, vars) {
    let str = t(key);
    for (const [name, value] of Object.entries(vars)) {
        str = str.split(`{{${name}}}`).join(String(value));
    }
    return str;
}

export function tp(key, n) {
    const variant = n === 1 ? `${key}.one` : `${key}.other`;
    return tpl(variant, {n});
}

/** Tells the browser and assistive technology the page language and names the tab in it. */
export function applyDocumentLocale() {
    document.documentElement.lang = getLocale();
    document.title = t('app.title');
}

export function applyTranslations(root) {
    root.querySelectorAll('[data-i18n]').forEach((el) => {
        el.textContent = t(el.dataset.i18n);
    });
    root.querySelectorAll('[data-i18n-placeholder]').forEach((el) => {
        el.placeholder = t(el.dataset.i18nPlaceholder);
    });
    root.querySelectorAll('[data-i18n-title]').forEach((el) => {
        el.title = t(el.dataset.i18nTitle);
    });
    root.querySelectorAll('[data-i18n-aria-label]').forEach((el) => {
        el.setAttribute('aria-label', t(el.dataset.i18nAriaLabel));
    });
    root.querySelectorAll('[data-i18n-alt]').forEach((el) => {
        el.alt = t(el.dataset.i18nAlt);
    });
}
